<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert v-model="showAlert" variant="warning" dismissible>
    {{ alertMsg }}
  </b-alert>

  <b-modal v-model="showModal" ref="delete" id="delete" title="Conferma cancellazioe" @ok="handleDelete" @cancel="handleCancel">
    <h3>Sei sicuro di voler cancellare la riga?</h3>
  </b-modal>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Dimensioni Equipaggiamento"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="4">
              <span class='label'>
                Codice ISO
              </span>
            </b-col>
            <b-col cols="8">
              <span class='label'>
                Dimensioni
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-input v-model="form_data.iso_code" class=""></b-form-input>
            </b-col>
            <b-col cols="8">
              <b-form-input v-model="form_data.size" class=""></b-form-input>
            </b-col>
          </b-row>            

          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-button variant="warning" @click="cancelEquipmentSize">Annulla</b-button>
            </b-col>          
            <b-col cols="7">
              &nbsp;
            </b-col>          
            <b-col cols="2">
              <b-button v-if="!current_id" variant="primary" @click="insertEquipmentSize">Inserisci</b-button>
              <b-button v-if="current_id" variant="success" @click="updateEquipmentSize">Aggiorna</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        title="Lista Dimensioni Equipaggiamento"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <table class="" :key="equipment_sizes.length">
                <thead>
                  <tr>
                    <th style="width: 0%;"></th>
                    <th style="width: 20%;">Codice ISO</th>
                    <th style="width: 75%;">Dimensioni</th>
                    <th style="width: 5%;"></th>
                  </tr>
                </thead>
                <tbody>                  
                  <tr v-for="equipment_size in equipment_sizes" :key="equipment_size.id" class="row-selection">
                    <td @click="editRow(equipment_size)" class="link" style="visibility: hidden;">{{ equipment_size.id }}</td>
                    <td @click="editRow(equipment_size)" class="link">{{ equipment_size.iso_code }}</td>
                    <td @click="editRow(equipment_size)" class="link">{{ equipment_size.size }}</td>
                  <td>
                      <i
                        class="fas fa-trash"
                        @click="deleteRecord(equipment_size)"
                        style="pointer: cursor !important;"
                      ></i>
                    </td>
                  </tr>                
                </tbody>
              </table>

              <!--
              <b-table
                :items="equipment_sizes"
                :fields="equipment_sizes_fields"
                :per-page="perPage"
                :current-page="currentPage"
                v-model:sort-by="sortBy"
                v-model:sort-desc="sortDesc"
                @row-clicked="selectEquipmentSize"
                @sort-changed="onSortChanged"
              >
                <template #cell(id)="data">
                  <span style="display:none">
                    {{ data.item.id }}
                  </span>
                </template>
              </b-table>
              -->
            </b-col>
            <b-col cols="10">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  @change="onPageChange"
                  class="my-3"
                ></b-pagination>
            </b-col>
            <b-col cols="2" style="margin-top: 1.5rem;">
                <b-form-select v-model="perPage" :options="[5, 10, 15, 20]" class="mb-3" style="width: 6rem;" @change="onPerPageChange"></b-form-select>
            </b-col>            
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>

</div>